import { RxRenewals } from "./RxRenewals";

export const RenewalsChosenStep = ({
  onContinue,
}: {
  onContinue: () => void;
}) => {
  return <RxRenewals onClose={onContinue} />;
};
